export default "__VITE_ASSET__B58rAYho__"